/* eslint-disable react/react-in-jsx-scope */
import { NavigateFunction } from 'react-router-dom';
import { discardAlterations } from 'Services/Api/_HumanWritten/BookingService/FerryTripBookingService';
import { AlterationExpirationDto } from 'Models/Dtos/BookingDtos';
import { clearFerryBookingTransactionIdFromStorage } from 'Services/Api/_HumanWritten/BookingService/BookingService';
import { clearStorageTransactionPrice } from 'Util/_HumanWritten/CartPriceSessionStorage';
import { newConfirmModal } from 'Views/Components/Modal/NewConfirmModal';
import { clearBookingWizardData } from './BookingWizardDataStore';

export default async function handleNavigation(bookingId: string, navigate: NavigateFunction) {
	return newConfirmModal(
		' Cancel changes?',
		// eslint-disable-next-line react/react-in-jsx-scope
		<div className="edit-booking-modal">
			<h5>This will discard any changes you have made.</h5>
		</div>,
		{
			cancelText: 'Back',
			confirmText: 'Yes, cancel',
		},
	)
		.then(async () => {
			try {
				await discardAlterations(navigate, {
					bookingIds: [bookingId],
					systemExpired: false,
				} as AlterationExpirationDto);
			} catch (e) {
				console.error(e);
			}
			clearFerryBookingTransactionIdFromStorage();
			// This will clear the new and old booking wizard data (if any)
			clearBookingWizardData();
			clearStorageTransactionPrice();
			console.log('returning true');
			return true;
		})
		.catch(() => {
			console.log('returning false');
			return false;
		});
}
